module.exports = __webpack_public_path__ + "img/Rectangle 251@2x.67f346c1.png";